import { forEach, get, isEmpty, reject, unary } from 'lodash/fp';
// @ts-expect-error - Automatic, Please fix when editing this file
import findActiveByTargetSegment from '@ahmdigital/offers/lib/model/offers/find-active-by-target-segment';
import getMelbourneTimezoneMoment from '@ahmdigital/logic/lib/utils/get-melbourne-timezone-moment';
// @ts-expect-error - Automatic, Please fix when editing this file
import isExpired from '@ahmdigital/offers/lib/model/offer/is-expired';

import { GET_ALL_OFFERS } from '../../../src/client/components/offers/logic/use-get-all-offers/queries.gql';
import { GET_PLACEHOLDERS_QUERY } from '../../../src/client/components/offers/logic/use-get-all-placeholders/query.gql';
import { TARGET_SEGMENT } from '../../../src/client/cms/constants';
import getCmsData from '../../../src/client/cms/utils/get-cms-data';
import uniqueContentWithDraftPrecedence from '../../../src/client/cms/utils/unique-content-with-draft-precedence';
import validateOffer from '../../../src/client/components/offers/logic/validate-offer';

const getOffersContent = async (dataset?: string, mode?: string) => {
  const { allOffer } = await getCmsData(GET_ALL_OFFERS, undefined, dataset, mode);
  const allOffers = uniqueContentWithDraftPrecedence(allOffer);

  const now = getMelbourneTimezoneMoment();
  const validOffers = forEach(
    unary(validateOffer),
    reject((offer) => isExpired(offer, { effectiveDate: now }), allOffers),
  );

  const activeOffers = findActiveByTargetSegment(validOffers, TARGET_SEGMENT.LOOKING_FOR_PRIVATE_HEALTH_INSURANCE, {
    effectiveDate: now.toDate(),
  });

  const placeholderData = await getCmsData(GET_PLACEHOLDERS_QUERY, undefined, dataset, mode);
  return {
    activeOffers: isEmpty(activeOffers) ? null : activeOffers,
    placeholders: get('allPlaceholder', placeholderData),
  };
};

export default getOffersContent;
